document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('input[name="size-toggle"]').forEach(function (toggle) {
    toggle.addEventListener('change', function () {
      const cmSizes = document.querySelectorAll('.cm-size');
      const inchSizes = document.querySelectorAll('.inches-size');

      if (this.value === 'cm') {
        cmSizes.forEach(el => el.style.display = '');
        inchSizes.forEach(el => el.style.display = 'none');
      } else {
        cmSizes.forEach(el => el.style.display = 'none');
        inchSizes.forEach(el => el.style.display = '');
      }
    });
  });
});
